import { useState } from "react";
import PlaceHolderControl from "./PlaceHolderControl";

interface IProps {
    defaultLocked?: boolean;
    loading?: boolean;
    label: string;
    children: JSX.Element;
    onUnlock?: () => void;

}

const ControlMask = (props: IProps) => {
    const [locked, setLocked] = useState(props.defaultLocked ?? false);

    if (props.loading)
        return <PlaceHolderControl
            label={props.label}
            loading
        />;

    if (locked)
        return <PlaceHolderControl
            label={props.label}
            onClick={() => {
                setLocked(false);
                props.onUnlock?.();
            }}
        />;

    return <>
        {props.children}
    </>;
}

export default ControlMask;